const audioManagerComponent = function (o) {
    //First, test that webAudio is supported:

    if (!(window.AudioContext || window.webkitAudioContext)) {
        return {
            isSupported: false,
        };
    }

    this.isSupported = true;

    //Vars relative to class:

    o = o || {};

    //Set up our audioContext and connect it to the speakers:

    var audioContext = window.AudioContext
        ? new window.AudioContext()
        : new window.webkitAudioContext();

    var gain = audioContext.createGainNode
        ? audioContext.createGainNode()
        : audioContext.createGain();

    gain.connect(audioContext.destination);

    var audio = [];

    var moduleType = 'webAudio';

    var a = document.createElement('audio');

    var audioFormat = a.canPlayType('audio/ogg')
        ? 'ogg'
        : a.canPlayType('audio/mp3')
        ? 'mp3'
        : 'wav';

    a = null;

    var _self = this;
    var debug = o.debug || false;
    var isMuted = o.muted || false;

    gain.gain.value = isMuted ? 0 : 1;

    //CLASSES -----------------------------

    var Audio_element = function (o) {
        o = o || {};

        var _self = this;
        this.id = o.id || '';
        this.path = o.path || '';
        this.isLoaded = false;
        this.looping = false;
        this.classes = o.classes || [];
        this.buffer = null;
        this.lastPlayTime = null;

        this.isPlaying = function () {
            if (!_self.buffer || !_self.lastPlayTime) {
                return false;
            }

            if (_self.looping) {
                return true;
            }

            if (
                new Date().getTime() - _self.lastPlayTime <
                _self.buffer.duration * 1000
            ) {
                return true;
            }

            return false;
        };
    };

    //END CLASSES ------------------------

    /*
     * Returns the format of audio the audioManager expects:
     */

    this.getFormat = function () {
        return audioFormat;
    };

    /*
     * Returns the module type of the audioManager:
     */

    this.getModuleType = function () {
        return moduleType;
    };

    this.isMuted = function () {
        return isMuted;
    };

    /*
     * Mutes audio globally
     * returns current state of isMuted:
     */

    this.mute = function () {
        if (isMuted) {
            return isMuted;
        }

        gain.gain.value = 0;
        isMuted = true;
        return isMuted;
    };

    /*
     * Unmutes audio globally
     * returns current state of isMuted:
     */

    this.unMute = function () {
        if (!isMuted) {
            return isMuted;
        }

        gain.gain.value = 1;
        isMuted = false;
        return isMuted;
    };

    /*
     * Toggles global audio mute setting
     * returns current state of isMuted:
     */

    this.toggleMute = function () {
        var methodName = isMuted ? 'unMute' : 'mute';
        return _self[methodName]();
    };

    /*
     * Add audio to the preloader to make it aware of them using add:
     */

    this.add = function (a) {
        //Catch any errors in the argument:

        if (!a || !a.length || typeof a === 'string') {
            return false;
        }

        for (var i = 0; i < a.length; i++) {
            if (!a[i].id) {
                continue;
            }

            var alreadyExists = false;

            for (var j = 0; j < audio.length; j++) {
                if (audio[j].id === a[i].id) {
                    alreadyExists = true;
                }
            }

            if (alreadyExists) {
                continue;
            }

            audio.push(
                new Audio_element({
                    id: a[i].id,
                    path: a[i].path,
                    classes: a[i].classes || [],
                }),
            );
        }

        return !!a.length;
    };

    var getAudioById = function (id) {
        var a = null;

        for (var i = 0; i < audio.length; i++) {
            if (id === audio[i].id) {
                a = audio[i];
                break;
            }
        }

        return a;
    };

    /*
     * Will return all audio data in the manifest to the user, or just data for the audio with id matching the argument.
     */

    this.getData = function (str, suppressErrors) {
        if (str) {
            var data = getAudioById(str);

            if (!data && debug && !suppressErrors) {
                return null;
            }
            return data;
        }

        return audio;
    };

    this.get = function (id) {
        var a = getAudioById(id);

        if (!a) {
            return null;
        }

        return a.buffer;
    };

    /*
     * Stop all audio that is currently playing.
     * Feed this an array of audio ID's you don't want to stop (optional)
     * First argument can be an array or a string if only one piece of audio is to be left playing:
     */

    this.stopAll = function (notThese) {
        if (notThese && typeof notThese === 'string') {
            notThese = [notThese];
        }

        for (var i = 0; i < audio.length; i++) {
            if (notThese && notThese.length) {
                var stopThis = true;

                for (var j = 0; j < notThese.length; j++) {
                    if (notThese[j] === audio[i].id) {
                        stopThis = false;

                        break;
                    }
                }

                if (!stopThis) {
                    continue;
                }
            }

            stopAudio(audio[i]);
        }
    };

    var stopAudio = function (el) {
        try {
            el.source.noteOff(0);
        } catch (err1) {
            try {
                el.source.stop(0);
            } catch (err2) {}
        }

        el.lastPlayTime = 0;
        el.looping = false;
    };

    this.stop = function (id) {
        var audioEl = getAudioById(id);

        if (!audioEl) {
            return false;
        }

        stopAudio(audioEl);
    };

    this.play = function (id, o) {
        if (!id) {
            return false;
        }

        o = o || {};

        if (typeof id !== 'string') {
            //Assume an array of ID's has been passed:
            for (var i = 0; i < id.length; i++) {
                _self.play(id[i], o);
            }
            return true;
        }

        var audioEl = getAudioById(id);

        if (!audioEl) {
            return false;
        }

        if (!audioEl.isLoaded) {
            return false;
        }

        if (audioEl.isPlaying() && !o.startAgain) {
            return true;
        }

        stopAudio(audioEl);
        audioEl.source = null;

        //TODO - do we need to stop the audio first?
        audioEl.source = audioContext.createBufferSource();
        audioEl.source.loop = o.loop ? true : false;
        audioEl.looping = o.loop ? true : false;
        audioEl.source.buffer = audioEl.buffer;
        audioEl.source.connect(gain);
        audioEl.source.onended = o.onEnd
            ? e => {
                  o.onEnd();
              }
            : null;
        try {
            audioEl.source.noteOn(0);
        } catch (err1) {
            try {
                audioEl.source.start(0);
            } catch (err2) {}
        }
        audioEl.lastPlayTime = new Date().getTime();
    };

    /*
     * This is our main load function. It expects an object as an argument with the following properties:
     * audio : (array:string) - an array of audio ID's for the preloader to load. Will log an error if an id passed isn't recognised.
     * onComplete : (function) - a function that'll be called when all audio has loaded. Nothing is passed to this function.
     * onAudioLoad : (function) - a function that'll be called when a piece of audio has loaded. It'll pass along the ID of that audio as first arg as well as percent loaded.
     */

    this.load = function (o) {
        o = o || {};

        //First, populate our audioToLoad based on what was passed through:

        var audioToLoad = [];

        if (o.audio) {
            var l = o.audio.length;

            for (var i = 0; i < l; i++) {
                var audioID = o.audio[i];

                var il = audio.length;

                var audioExists = false;

                //Make sure we're aware of our audio based on its ID:

                for (var j = 0; j < il; j++) {
                    if (audio[j].id === audioID) {
                        audioExists = audio[j];

                        break;
                    }
                }

                if (!audioExists) {
                    continue;
                }

                var alreadyInArray = false;

                //Make sure we're not duplicating any image ID's:

                for (var k = 0; k < audioToLoad.length; k++) {
                    if (audioToLoad[k].id === audioID) {
                        alreadyInArray = true;

                        break;
                    }
                }

                if (alreadyInArray) {
                    continue;
                }

                audioToLoad.push(audioExists);
            }
        } else {
            audioToLoad = audio;
        }

        return loadAudio(audioToLoad, o.onAudioLoad, o.onComplete);
    };

    var loadAudio = function (toLoad, onLoad, onComplete) {
        var audioLoaded = 0;

        var audioToLoad = toLoad.length;

        if (!audioToLoad) {
            if (onComplete) {
                onComplete();
            }

            return false;
        }

        var handleLoad = function (id) {
            audioLoaded++;

            var percentComplete = Math.floor((audioLoaded / audioToLoad) * 100);

            if (onLoad) {
                onLoad(id, percentComplete);
            }

            if (audioLoaded === audioToLoad && onComplete) {
                onComplete();
            }
        };

        var getLoadFunction = function (audioObject) {
            return function (audioObject) {
                var request = new XMLHttpRequest();

                request.id = audioObject.id;

                request.responseType = 'arraybuffer';

                request.sent = false;

                request.addEventListener(
                    'load',

                    function (e) {
                        audioContext.decodeAudioData(
                            e.target.response,

                            function onSuccess(decodedBuffer) {
                                audioObject.buffer = decodedBuffer;

                                audioObject.isLoaded = true;

                                handleLoad(audioObject.id);
                            },

                            function (e) {
                                // Do nothing
                            },
                        );
                    },

                    false,
                );

                request.open('GET', audioObject.path, true);

                request.send();
            };
        };

        for (var i = 0; i < audioToLoad; i++) {
            var audToLoad = toLoad[i];

            if (audToLoad.isLoaded) {
                handleLoad(audToLoad.id);
                continue;
            }
            getLoadFunction()(audToLoad);
        }

        return true;
    };

    /*
     * Feed an array of classes and it'll load all audio matching those classes!
     * If a string is fed, it'll act like an array with one entry
     */
    this.loadByClass = function (classes, o) {
        o = o || {};

        if (!classes) {
            return false;
        }

        if (typeof classes === 'string') {
            classes = [classes];
        }

        var idsToLoad = [];

        for (var i = 0; i < classes.length; i++) {
            var cls = classes[i].split(' ');

            for (var j = 0; j < audio.length; j++) {
                var aud = audio[j];
                var matchesAllClasses = true;

                for (var k = 0; k < cls.length; k++) {
                    var matchesClass = false;

                    for (var l = 0; l < aud.classes.length; l++) {
                        if (aud.classes[l] === cls[k]) {
                            matchesClass = true;
                            break;
                        }
                    }
                    if (!matchesClass) {
                        matchesAllClasses = false;
                        break;
                    }
                }

                if (matchesAllClasses) {
                    idsToLoad.push(aud.id);
                }
            }
        }

        return _self.load({
            audio: idsToLoad,
            onAudioLoad: o.onAudioLoad || null,
            onComplete: o.onComplete || null,
        });
    };
};

const AudioManager = new audioManagerComponent();
export { AudioManager };
